export default (
  RecipientModelsCache,
) => () => {
  RecipientModelsCache.resetRecipientsModels();
};
